"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVideoContentStyle;
function createVideoContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVWaWRlb0NvbnRlbnRTdHlsZSIsIl9yZWYiLCJ2aWRlb0hlaWdodCIsImhlaWdodCIsIndpZHRoIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L1ZpZGVvQ29udGVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVWaWRlb0NvbnRlbnRTdHlsZSh7IHZpZGVvSGVpZ2h0IH06IFN0cmljdFN0eWxlT3B0aW9ucykge1xuICByZXR1cm4ge1xuICAgIGhlaWdodDogdmlkZW9IZWlnaHQsXG4gICAgd2lkdGg6ICcxMDAlJ1xuICB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFFZSxTQUFTQSx1QkFBdUJBLENBQUFDLElBQUEsRUFBc0M7RUFBQSxJQUFuQ0MsV0FBVyxHQUFBRCxJQUFBLENBQVhDLFdBQVc7RUFDM0QsT0FBTztJQUNMQyxNQUFNLEVBQUVELFdBQVc7SUFDbkJFLEtBQUssRUFBRTtFQUNULENBQUM7QUFDSCJ9